import React from 'react';
import divider from '../images/divider-colored.svg';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import Swal from 'sweetalert2';

const SubscribeBlog = () => {
  const [email, setEmail] = React.useState('');

  const handleSubmit = e => {
    e.preventDefault();
    addToMailchimp(email)
      .then(data => {
        Swal.fire({
          icon: data.result,
          title: data.msg,
          showConfirmButton: false,
          timer: 1800,
        });
      })
      .catch(error => {
        console.log(error);
      });
    e.target.reset();
  };
  const handleEmailChange = event => {
    setEmail(event.currentTarget.value);
  };
  return (
    <section className='section'>
      <div className='subscribe-blog-heading'>
        <div className='columns'>
          <div className='column'>
            <img src={divider} alt='divider' />
            <p style={{ color: '#333' }}>Subscribe to our blog</p>
            <form onSubmit={handleSubmit}>
              <div>
                <input
                  className='subscribe-blog-email'
                  placeholder='Email address'
                  name='email'
                  type='email'
                  required
                  onChange={handleEmailChange}
                  style={{
                    height: '45px',
                    marginTop: '62px',
                    fontSize: '18px',
                    paddingLeft: '15px',
                    color: '#555',
                    backgroundColor: '#f9f9f9',
                    borderRadius: '20px',
                  }}
                />
                <button
                  className='button'
                  type='submit'
                  style={{ marginTop: '62px', marginLeft: '20px' }}
                >
                  <p className='button-text'>Subscribe</p>
                </button>
              </div>
            </form>
            <p className='pp'>
              By providing your email, you indicate you have read and understood
              our Privacy Policy.
            </p>
          </div>
          <div className='column'>
            <p className='subscribe-blog-placeholder'>
              Join our mailing list to get our latest posts on tech, product,
              design, business and catch up with us on our latest reading
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscribeBlog;
